
import styled from 'styled-components';

export const BackButtonWrapper = styled.div`
  padding: 0 1.2%;
`;
